import type { IEmailCampaignTopLink } from "api/rpc/2024-04/facilityAdmin/marketing/emailCampaigns";

export function normalizeEmailLinkUrl(url: string): string {
  const trimmed = url.trim();
  if (trimmed.length === 0) {
    return "";
  }

  try {
    return new URL(trimmed, "https://placeholder.local").href.replace(/\/$/, "");
  } catch {
    return trimmed.replace(/\/$/, "");
  }
}

export function getEmailCampaignTopLinkLabel(link: IEmailCampaignTopLink): string {
  const label = link.label?.trim();
  if (label) {
    return label;
  }

  try {
    const parsed = new URL(link.url);
    const path = parsed.pathname === "/" ? "" : parsed.pathname;
    return `${parsed.hostname}${path}`;
  } catch {
    return link.url;
  }
}

export function sortEmailCampaignTopLinks(
  links: IEmailCampaignTopLink[],
  ascending: boolean,
): IEmailCampaignTopLink[] {
  const sorted = [...links];
  sorted.sort((left, right) => (ascending ? left.count - right.count : right.count - left.count));
  return sorted;
}
